import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user2",
  "use": "icon-user2-usage",
  "viewBox": "152.9 54.9 237.1 220.2",
  "content": "<symbol viewBox=\"152.9 54.9 237.1 220.2\" id=\"icon-user2\">\r\n<path d=\"M288.4,208v-14c18.7-10.5,33.9-36.7,33.9-62.9c0-42.1,0-76.2-50.8-76.2s-50.8,34.1-50.8,76.2c0,26.2,15.2,52.4,33.9,62.9v14\r\n\tc-57.5,4.7-101.6,32.9-101.6,67.1h237.1C390.1,241,345.9,212.7,288.4,208z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/user2.svg
// module id = +Xj0
// module chunks = 0